import { render, staticRenderFns } from "./MyTasksPage.vue?vue&type=template&id=afdf03e8&scoped=true&"
import script from "./MyTasksPage.vue?vue&type=script&lang=js&"
export * from "./MyTasksPage.vue?vue&type=script&lang=js&"
import style0 from "./MyTasksPage.vue?vue&type=style&index=0&id=afdf03e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdf03e8",
  null
  
)

/* custom blocks */
import block0 from "./MyTasksPage.vue?vue&type=custom&index=0&blockType=br"
if (typeof block0 === 'function') block0(component)

export default component.exports